<template>
  <div v-if="text" class="container seo-text-page">
    <seo-text :text="text" />
  </div>
</template>

<script setup lang="ts">
import SeoText from './seo-text.vue';
import useSeoTextPage from './useSeoTextPage';

const { text } = useSeoTextPage();

defineOptions({
  name: 'seo-text-page',
});
</script>

<style lang="scss">
.seo-text-page {
  --offset: 32px;
  margin-bottom: var(--offset);

  @include breakpoint("tablet") {
    --offset: 40px;
  }

  @include breakpoint("desktop") {
    --offset: 56px;
  }
}
</style>
